export default "__VITE_ASSET__M$BQdX_p__"